import { Tabs, Tab, Box } from '@mui/material';
import MechanicalTab from 'src/@carketa/sales-packet/components/MechanicalTab';
import React, { useMemo, useState } from 'react';
import { CarketaDisclosure } from 'src/@carketa/sales-packet/components/CarketaDisclosure';

type VehicleConditionReportSection = {
  vehicle: any;
  vehicle_inspections: any;
  inspectionId: string | null;
  pdfMode?: boolean;
};

const VehicleConditionReportSection = ({
  vehicle,
  vehicle_inspections,
  inspectionId,
  pdfMode,
}: VehicleConditionReportSection) => {
  const [value, setValue] = useState(0);

  const vehicle_inspection = useMemo(() => {
    let inspection = null;
    inspection = vehicle_inspections?.find(
      (inspection: any) => inspection.id === inspectionId
    );
    if (!inspection && vehicle_inspections)
      inspection = vehicle_inspections?.[0];
    return inspection;
  }, [inspectionId, vehicle_inspections]);

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  function TabPanel(props: any) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ pt: 3 }}>
            <Box>{children}</Box>
          </Box>
        )}
      </div>
    );
  }

  const tabLabel = (label: string) => {
    return (
      <div className="flex items-center">
        <p className="ml-1 font-bold">{label}</p>
      </div>
    );
  };

  if (!vehicle_inspection) return <>loading..</>;

  return (
    <div id="vehicle-reports" className="p-2 w-full">
      <div className="border-t mt-5 mb-4 border-gray-300 w-full " />
      <div className="flex justify-between mb-4 flex-col">
        <p className="text-16 font-medium">
          {vehicle_inspection.inspection_template.title}
        </p>
        <p className="text-16 ">
          {vehicle.year} {vehicle.make} {vehicle.model} {vehicle.trim}
        </p>
      </div>
      <div className="flex">
        <p className="text-14 mr-4 ">VIN</p>
        <p className="text-14 gray-500">{vehicle.vin}</p>
      </div>
      <div className="flex">
        <p className="text-14 mr-4 ">STOCK#</p>
        <p className="text-14 gray-500">{vehicle.stocknumber}</p>
      </div>
      <Box sx={{ width: '100%', mt: '15px' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            sx={{
              '.Mui-selected': {
                color: `rgba(86, 202, 0, 1) !important`,
              },
              '.MuiTabs-indicator': {
                backgroundColor: 'lightGreen',
              },
            }}
            value={value}
            onChange={handleChange}
          >
            <Tab label={tabLabel(`MECHANICAL`)} {...a11yProps(0)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <MechanicalTab vehicle_inspection={vehicle_inspection} />
        </TabPanel>
      </Box>
      <Box sx={{ display: pdfMode ? '' : 'none' }}>
        <CarketaDisclosure />
      </Box>
    </div>
  );
};

export default VehicleConditionReportSection;
